export const actions = {
    updateFormData({ commit }, formData) {
        const sanitizedFormData = JSON.parse(JSON.stringify(formData));
        commit('setFormData', sanitizedFormData);
    },
};